import { Typography } from '@mui/material';
import React, { FC } from 'react';
import { palette } from '../../../theme';

interface COEDurationInputProps {
  value: string;
  onChange: (evt: any) => void;
  fontSize?: number;
  height?: number;
  width?: number;
}

const COEDurationInput: FC<COEDurationInputProps> = (props) => {
  function isValidNumberString(inputString: string) {
    return /^[0-9]+$/.test(inputString);
  }

  function formatTimeComponent(component: any) {
    return component.toString().padStart(2, '0');
  }

  function secondsToHHMMSS(seconds: number) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    const formattedHours = formatTimeComponent(hours);
    const formattedMinutes = formatTimeComponent(minutes);
    const formattedSeconds = formatTimeComponent(remainingSeconds);

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }

  function HHMMSSToSeconds(timeString: string) {
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    const totalSeconds = hours * 3600 + minutes * 60 + seconds;
    return totalSeconds;
  }

  function getTimeComponent(type: 'minutes' | 'seconds' | 'hours') {
    const parts = secondsToHHMMSS(parseInt(props.value)).split(':');
    switch (type) {
      case 'seconds':
        return parts[2];
      case 'minutes':
        return parts[1];
      default:
        return parts[0];
    }
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <input
        type="text"
        style={{
          borderRadius: 12,
          height: props.height ? props.height : 40,
          width: props.width ? props.width : 50,
          textAlign: 'center',
          fontSize: props.fontSize ? props.fontSize : 14,
          borderColor: palette.grey[300],
        }}
        placeholder="HH"
        value={getTimeComponent('hours')}
        onChange={(evt) => {
          let hoursStr = evt.target.value;

          if (!isValidNumberString(hoursStr)) {
            return;
          }

          if (hoursStr.length > 2) {
            hoursStr = hoursStr.substring(1);
          }

          const currentHHMMSS = secondsToHHMMSS(parseInt(props.value));

          const updatedHHMMSS = hoursStr + currentHHMMSS.substring(2);

          props.onChange(HHMMSSToSeconds(updatedHHMMSS));
        }}
      ></input>
      <Typography style={{ margin: 3 }} fontSize={props.fontSize ? props.fontSize : 14}>
        :
      </Typography>
      <input
        type="text"
        style={{
          borderRadius: 12,
          height: props.height ? props.height : 40,
          width: props.width ? props.width : 50,
          textAlign: 'center',
          fontSize: props.fontSize ? props.fontSize : 14,
          borderColor: palette.grey[300],
        }}
        placeholder="MM"
        value={getTimeComponent('minutes')}
        onChange={(evt) => {
          let minutesStr = evt.target.value;

          if (!isValidNumberString(minutesStr)) {
            return;
          }

          if (minutesStr.length > 2) {
            minutesStr = minutesStr.substring(1);
          }

          if (parseInt(minutesStr) > 59) {
            minutesStr = '59';
          }

          const currentHHMMSS = secondsToHHMMSS(parseInt(props.value));

          const updatedHHMMSS = currentHHMMSS.substring(0, 3) + minutesStr + currentHHMMSS.substring(5);

          props.onChange(HHMMSSToSeconds(updatedHHMMSS));
        }}
      ></input>
      <Typography variant="subtitle1" style={{ margin: 3 }}>
        :
      </Typography>
      <input
        type="text"
        style={{
          borderRadius: 12,
          height: props.height ? props.height : 40,
          width: props.width ? props.width : 50,
          textAlign: 'center',
          fontSize: props.fontSize ? props.fontSize : 14,
          borderColor: palette.grey[300],
        }}
        placeholder="SS"
        value={getTimeComponent('seconds')}
        onChange={(evt) => {
          let secondsStr = evt.target.value;

          if (!isValidNumberString(secondsStr)) {
            return;
          }

          if (secondsStr.length > 2) {
            secondsStr = secondsStr.substring(1);
          }

          if (parseInt(secondsStr) > 59) {
            secondsStr = '59';
          }

          const currentHHMMSS = secondsToHHMMSS(parseInt(props.value));

          const updatedHHMMSS = currentHHMMSS.substring(0, 6) + secondsStr;

          props.onChange(HHMMSSToSeconds(updatedHHMMSS));
        }}
      ></input>
    </div>
  );
};

export default COEDurationInput;
